import { __awaiter, __extends, __generator } from "tslib";
import { AbstractConnection } from "./AbstractConnection.mjs";
var DirectConnection = /** @class */ (function (_super) {
    __extends(DirectConnection, _super);
    function DirectConnection(options, logger, additionalOptions) {
        var _this = this;
        throw new Error('DirectConnection is not implemented in a browser environment');
        _this = _super.call(this, options, logger, additionalOptions) || this;
        return _this;
    }
    Object.defineProperty(DirectConnection.prototype, "port", {
        get: function () {
            return this._port;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DirectConnection.prototype, "hasSocket", {
        // eslint-disable-next-line @typescript-eslint/class-literal-property-style
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    DirectConnection.prototype.sendRaw = function (line) {
        void line;
    };
    DirectConnection.prototype.connect = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    DirectConnection.prototype.disconnect = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    return DirectConnection;
}(AbstractConnection));
export { DirectConnection };
